var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlMaskFilled = function SvgHtlMaskFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 11.735a7.41 7.41 0 0 1-3.948-1.6V4.273h7.9v5.862A7.4 7.4 0 0 1 8 11.735ZM7 8.766a.5.5 0 1 0 0 1h2a.5.5 0 0 0 0-1H7ZM7 6.44a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 12.235a7.9 7.9 0 0 1-4.248-1.7.5.5 0 0 1-.2-.4v-5.86a.5.5 0 0 1 .5-.5h7.9a.5.5 0 0 1 .5.5v5.861a.5.5 0 0 1-.2.4A7.9 7.9 0 0 1 8 12.236ZM4.552 9.882A6.635 6.635 0 0 0 8 11.235a6.633 6.633 0 0 0 3.448-1.353V4.775h-6.9l.004 5.107Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.948 10.636a.5.5 0 0 1-.354-.854l1.857-1.857a1.85 1.85 0 0 0-1.461-3.152.502.502 0 0 1-.083-1 2.85 2.85 0 0 1 2.252 4.856L12.3 10.49a.5.5 0 0 1-.352.146ZM4.052 10.636a.501.501 0 0 1-.354-.146L1.841 8.633a2.85 2.85 0 0 1 2.252-4.856.502.502 0 0 1-.083 1 1.85 1.85 0 0 0-1.462 3.148l1.857 1.858a.5.5 0 0 1-.354.854h.001Z"
  })));
};
export default SvgHtlMaskFilled;